import React from "react";
import "../Styles/EduandCarrer.css";
import QualificationIcon from "../assests/images/quali-icon.png";
import CollegeIcon from "../assests/images/college-icon.png";
import WorkIcon from "../assests/images/work-icon.png";
import SalaryIcon from "../assests/images/salary-icon.png";
import CURRENCY_META from "../components/currencyMeta";

const EducationAndCareer = ({
  UserData,
  selectedQualification,
  qualifications,
}) => {
  return (
    <div className="container-for-edu p-4 mx-3">
      <h5 className="edu-title mb-4">Education and career</h5>

      <div className="row text-center mb-4">
        {/* Qualification */}
        <div className="col-6 col-md-3 mb-3">
          <img src={QualificationIcon} alt="" className="edu-icons" />

          {selectedQualification ? (
            <div className="title-for-car">
              {" "}
              {qualifications[selectedQualification - 1]?.ShortName}
            </div>
          ) : (
            <div className="title-for-car"></div>
          )}
        </div>

        {/* College */}
        <div className="col-6 col-md-3 mb-3">
          <img src={CollegeIcon} alt="" className="edu-icons" />
          <div className="title-for-car">{UserData?.CollageName}</div>
        </div>

        {/* Working as */}
        <div className="col-6 col-md-3 mb-3">
          <img src={WorkIcon} alt="" className="edu-icons" />
          <div className="title-for-car">{UserData?.JobRole}</div>
        </div>

        {/* Salary */}
        <div className="col-6 col-md-3 mb-3">
          <img src={SalaryIcon} alt="" className="edu-icons" />

          {/* <div className="title-for-car"> {UserData?.SalaryCurrency} {UserData?.Salary} LPA</div> */}
          <div className="title-for-car">
            {CURRENCY_META[UserData?.SalaryCurrency]?.symbol ||
              UserData?.SalaryCurrency}{" "}
            {UserData?.SalaryCurrency === "INR"
              ? UserData?.Salary / 100
              : UserData?.Salary}{" "}
            {UserData?.SalaryCurrency === "INR" ? "LPA" : "K"}
          </div>
        </div>
      </div>

      {/* Career Goals */}
      <div
        className="p-4 rounded  shadow-sm "
        style={{ backgroundColor: "#F9F6F8" }}
      >
        <div className="title-for-carr mb-1">Career goals</div>
        <p className="mb-0 mt-1">{UserData?.CarrerGoals}</p>
      </div>
    </div>
  );
};

export default EducationAndCareer;
